<template>
  <div>
    <div class="breadcrumb-list">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">Profile</li>
      </ol>
      <div class="emp-button btn-align text-right" v-if="user && (user.type=='MANAGER' || (user.type=='EMPLOYEE' && user.managerAccess=='yes'))">
        <button type="button" data-toggle="modal" data-target="#creat-employee" class="btn btn-outline-primary">Create
          New Employee
        </button>
      </div>
    </div>
    <div class="main-box two-column">
      <employee-sidebar v-bind:employeeData="employee"></employee-sidebar>
      <div class="emplyee-info-wrp">
        <h3>Manage Permissions</h3>
        <div>
          <div v-for="permission in permissions" :key="permission.id">
            <label>
              <input type="checkbox" :value="permission.id" v-model="selectedPermissions" />
              {{ permission.label }}
            </label>
          </div>
          <button @click="savePermissions">Save Permissions</button>
        </div>
      </div>

    </div>
    <createEmployeeModal></createEmployeeModal>
  </div>
</template>

<script>
import createEmployeeModal from "./createEmployeeModal";
import DatePicker from "vue2-datepicker";
import employeeSidebar from "./employeeSidebar";
import ClipLoader from "vue-spinner/src/ClipLoader";
import Swal from "sweetalert2";

export default {
  components: {
    createEmployeeModal,
    DatePicker,
    employeeSidebar,
    ClipLoader
  },
  data() {
    return {
      loading: true,
      employee: this.$store.getters.getEmployeeProfileId,
      company_id    : this.$store.getters.getSelectedCompany.id,
      permissions: [],
      selectedPermissions: [],
      user:this.$store.getters.getUser
    };
  },
   created() {
     this.getPermissions();
     this.getAssignPermissions();
  },
  methods: {
     savePermissions() {
      this.$axios({
        method: "POST",
        data: {
          user_id: this.employee.id,
          permission_ids: this.selectedPermissions,
        },
        url: this.$GetEmployeePermissions+'/update',
        headers: this.getAuthHeader(),
      }).then((res) => {
        if (res.data.status === 200) {
          alert('Permissions updated')
        }
      });
    },

    getPermissions(){
      this.$axios({
        method: "get",
        params: {
          company_id: this.company_id,
        },
        url: this.$GetEmployeePermissions,
        headers: this.getAuthHeader(),
      }).then((res) => {
        if (res.data.status == 200) {
          this.permissions = res.data.result;

        }
      });
    },
    getAssignPermissions(){
      this.$axios({
        method: "get",
        params: {
          company_id: this.company_id,
        },
        url: this.$GetEmployeePermissions+'/'+this.employee.id,
        headers: this.getAuthHeader(),
      }).then((res) => {
        if (res.data.status == 200) {
          console.log(res.data.result,'res.data.result');
          this.selectedPermissions = res.data.result;
        }
      });
    },
  },
};
</script>
